import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  updateRoomFacilitie,
  getRoomFacilitieDataWithId,
} from "adminApi/RoomFacilitesApi/RoomFacilites";
import { validateForm } from "utils/validation";
import { RoomFacilityTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditRoomFacilityTypeForm from "./Componates/EditRoomFacilityTypeForm";
import fields from "../json/RoomFacilityTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditRoomFacilityType = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, RoomFacilityTypeRules);

  // Fetch existing record by ID and populate form
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoomFacilitieDataWithId, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await updateRoomFacilitie({ id, data: formValues }),
    (vals) => {
      const err = validateForm(vals, RoomFacilityTypeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Facility Type updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditRoomFacilityTypeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Room Facility Type"
      />
    </>
  );
};

export default EditRoomFacilityType;
